import { httpBlobGetServiceApiRoot } from "../sharedService/httpService";

export function generatePresignedUrl(reqBody: any) {
  return httpBlobGetServiceApiRoot.post(
    `/api/Bllob/GeneratePresignedUrl`,
    reqBody
  );
}
